import Header from './SupplierHeaderPage';

export default Header;
